module.exports = __webpack_public_path__ + "img/pos-parking.a7f210d1.png";